const OtpTypeEnum = Object.freeze({
  1: 'Numeric',
  2: 'Alphanumeric'
})

export { OtpTypeEnum }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/otp/enums/OtpTypeEnum.js